module.exports = __webpack_public_path__ + "static/ImportProduct-5ed194f92fdc5e9ee2c6398a30c3a0b8.png";